import React, { useState, useEffect } from 'react';
import { Outlet } from 'react-router-dom';
import NavBar from './NavBar';
import SideBar from './SideBar';
import Footer from './Footer';
import PerfectScrollbar from 'perfect-scrollbar';
import '../../assets/fonts/google-font.css';
import '../../assets/css/nucleo-icons.css';
import '../../assets/css/nucleo-svg.css';
import '../../assets/css/genius-baby.css';

function Layout() {
    document.body.classList.add('g-sidenav-show', 'bg-gray-100');

    if (document.getElementsByClassName('main-content')[0]) {
        const mainpanel = document.querySelector('.main-content');
        const ps = new PerfectScrollbar(mainpanel);
    };
    if (document.getElementsByClassName('sidenav')[0]) {
        const sidebar = document.querySelector('.sidenav');
        const ps1 = new PerfectScrollbar(sidebar);
    };

    const [breadcrum, setBreadcrum] = useState({
        title: 'Dashboard',
        navigation: 'dashboard'
    });

    const handleBreadcrumChange = (title, navigation) => {
        setBreadcrum({ title: title, navigation: navigation });
        //console.log(breadcrum);
    };

    const handleSidebarToggle = (e) => {
        let body = document.getElementsByTagName('body')[0];
        let iconSidenav = document.getElementById('iconSidenav');
        let className = 'g-sidenav-pinned';

        if (body.classList.contains(className)) {
            body.classList.remove(className);
        } else {
            body.classList.add(className);
            iconSidenav.classList.remove('d-none');
        }
    }

    return (
        <React.Fragment>
            <SideBar handleSidebarToggle={handleSidebarToggle} handleBreadcrumChange={handleBreadcrumChange} />
            <main className="main-content position-relative max-height-vh-100 h-100 border-radius-lg ps ps--active-y">
                <NavBar handleSidebarToggle={handleSidebarToggle} breadcrum={breadcrum} />
                <div className="container-fluid py-4">
                    <Outlet />
                </div>
                <Footer />
            </main>
        </React.Fragment>
    )
}

export default Layout